import { App as AntdApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { useEffect } from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";

import { AppRoutes } from "@/routes/AppRoutes";
import { useThemeStore } from "@/stores/themeStore";
import { buildAdminTheme } from "@/theme/index";
import "@/styles/global.css";

dayjs.locale("zh-cn");

function SessionEndedListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const onEnd = () => {
      navigate("/login", { replace: true, state: { reason: "session" } });
    };
    window.addEventListener("admin:session-ended", onEnd);
    return () => window.removeEventListener("admin:session-ended", onEnd);
  }, [navigate]);

  return null;
}

export default function App() {
  const mode = useThemeStore((s) => s.mode);

  return (
    <ConfigProvider locale={zhCN} theme={buildAdminTheme(mode)}>
      <AntdApp>
        <BrowserRouter>
          <SessionEndedListener />
          <AppRoutes />
        </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  );
}
